<template>
  <div ref="containerRef" class="animacion-elegante">
          <div class="rasgado rasgado-superior"></div>

    <!-- Confeti decorativo 1 (Esquina superior izquierda) -->
    <img
      ref="confeti1Ref"
      src="@/assets/3.avif"
      alt="Confeti Superior Izquierda"
      class="confeti-decorativo c1"
    />

    <!-- Confeti decorativo 2 (Esquina superior derecha) -->
    <img
      ref="confeti2Ref"
      src="@/assets/3.avif"
      alt="Confeti Superior Derecha"
      class="confeti-decorativo c2"
    />

    <!-- Lazo decorativo -->
    <img
      ref="lazoRef"
      src="@/assets/lazo.avif"
      alt="Lazo"
      class="lazo-decorativo"
    />

    <!-- Bola de disco -->
    <img
      ref="bolaRef"
      src="@/assets/bola.avif"
      alt="Bola de disco"
      class="bola-disco"
    />

    <!-- Bola de disco chica nueva -->
    <img
      ref="bolaChicaRef"
      src="@/assets/bola1.avif"
      alt="Bola chica"
      class="bola-disco-chica"
    />

    <!-- Bola nueva genérica -->
    <img
      ref="bolaPngRef"
      src="@/assets/bola.avif"
      alt="Bola decorativa"
      class="bola-png-decorativa"
    />

    <!-- Estrellas decorativas originales -->
    <img
      ref="estrellasRef"
      src="@/assets/estre.png"
      alt="Estrellas"
      class="estrellas-decorativas"
    />

    <!-- Estrella individual nueva -->
    <img
      ref="estrePngRef"
      src="@/assets/estre.png"
      alt="Estrella individual"
      class="estrella-individual"
    />

    <!-- Foto principal -->
    <img
      ref="fotoRef"
      src="@/assets/unnamed (20).webp"
      alt="Foto destacada"
      class="foto-elegante"
    />

    <!-- Foto secundaria ladeada al revés -->
    <img
      ref="foto2Ref"
      src="@/assets/unnamed (19).webp"
      alt="Otra foto"
      class="foto-elegante-reversa"
    />
          <div class="rasgado rasgado-inferior"></div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'AnimacionFotoDisco',
  setup() {
    const containerRef = ref(null)
    const fotoRef = ref(null)
    const foto2Ref = ref(null)
    const bolaRef = ref(null)
    const estrellasRef = ref(null)
    
    // Nuevas referencias solicitadas
    const bolaPngRef = ref(null)
    const estrePngRef = ref(null)
    const lazoRef = ref(null)
    const bolaChicaRef = ref(null)
    const confeti1Ref = ref(null)
    const confeti2Ref = ref(null)

    const animate = () => {
      const tl = gsap.timeline()

      // Aseguramos estados iniciales limpios antes de la reproducción
      gsap.set([
        confeti1Ref.value, confeti2Ref.value, lazoRef.value, 
        bolaChicaRef.value, bolaPngRef.value, estrePngRef.value
      ], { opacity: 0 })

      // 1. Entran los dos confetis del fondo desde arriba con escalado
      tl.fromTo(
        [confeti1Ref.value, confeti2Ref.value],
        { y: -80, opacity: 0, scale: 0.7 },
        { y: 0, opacity: 1, scale: 1, duration: 1.2, ease: 'power2.out', stagger: 0.2 }
      )

      // 2. Animación de la primera imagen (entrada desde abajo con inclinación)
      .fromTo(
        fotoRef.value,
        { y: 150, opacity: 0, rotate: -12, scale: 0.8 },
        { y: 0, opacity: 1, rotate: -4, scale: 1, duration: 1.4, ease: 'power3.out' },
        '-=0.8'
      )

      // 3. Bola de disco original con rotación
      .fromTo(
        bolaRef.value,
        { scale: 0.5, opacity: 0, rotate: 0 },
        { scale: 1, opacity: 1, rotate: 360, duration: 1.8, ease: 'power2.out' },
        '-=0.8'
      )

      // 4. Nueva bola chica y nueva bola.png saltando al unísono con efecto 'back'
      .fromTo(
        [bolaChicaRef.value, bolaPngRef.value],
        { scale: 0, opacity: 0, y: 50 },
        { scale: 1, opacity: 1, y: 0, duration: 1.2, ease: 'back.out(1.5)', stagger: 0.15 },
        '-=1.2'
      )

      // 5. Estrellas decorativas que aparecen después
      .fromTo(
        estrellasRef.value,
        { opacity: 0, y: -20, scale: 0.5 },
        { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: 'back.out(1.7)' },
        '-=1.0'
      )

      // 6. Nueva estrella individual (estre.png) con un destello rápido de escala
      .fromTo(
        estrePngRef.value,
        { opacity: 0, scale: 0, rotation: -90 },
        { opacity: 1, scale: 1, rotation: 0, duration: 1, ease: 'back.out(2)' },
        '-=0.8'
      )

      // 7. El lazo decorativo aparece cayendo elegantemente
      .fromTo(
        lazoRef.value,
        { y: -50, scale: 0.6, opacity: 0 },
        { y: 0, scale: 1, opacity: 1, duration: 1.2, ease: 'elastic.out(1, 0.75)' },
        '-=0.7'
      )

      // 8. Segunda imagen (con inclinación opuesta y entrada desde abajo)
      .fromTo(
        foto2Ref.value,
        { y: 150, opacity: 0, rotate: 12, scale: 0.8 },
        { y: 0, opacity: 1, rotate: 4, scale: 1, duration: 1.4, ease: 'power3.out' },
        '-=0.8'
      )

      // 9. Animación en loop infinito para dar dinamismo a las bolas de disco y estrellas
      .add(() => {
        gsap.to([bolaRef.value, bolaChicaRef.value, bolaPngRef.value], {
          y: '+=10',
          rotation: '+=5',
          duration: 2,
          ease: 'sine.inOut',
          yoyo: true,
          repeat: -1,
          stagger: 0.2
        })

        gsap.to([estrellasRef.value, estrePngRef.value, lazoRef.value], {
          scale: 1.08,
          duration: 1.5,
          ease: 'sine.inOut',
          yoyo: true,
          repeat: -1,
          stagger: 0.15
        })
      })
    }

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.15 }) // Umbral mejorado para pantallas móviles

      if (containerRef.value) observer.observe(containerRef.value)
    })

    return {
      containerRef,
      fotoRef,
      foto2Ref,
      bolaRef,
      estrellasRef,
      bolaPngRef,
      estrePngRef,
      lazoRef,
      bolaChicaRef,
      confeti1Ref,
      confeti2Ref
    }
  }
}
</script>

<style scoped>
.animacion-elegante {
  position: relative;
  width: 100%;
  margin-top:80px;
  padding: px 0 200px;
  display: flex;
  margin-bottom: 0px;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.foto-elegante,
.foto-elegante-reversa {
  width: 300px;
  max-width: 90%;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0;
  transform-origin: center;
  margin: 40px 0;
}

.foto-elegante {
  transform: rotate(-4deg);
  z-index: 2;
}

.foto-elegante-reversa {
  transform: rotate(4deg);
  z-index: 1;
}

/* --- ESTILOS DE ELEMENTOS PREEXISTENTES --- */
.bola-disco {
  width: 140px;
  margin-top: 0;
  margin-left: 50%;
  opacity: 0;
  transform-origin: center;
  z-index: 1;
  margin-bottom: -50px;
}

.estrellas-decorativas {
  width: 120px;
  position: absolute;
  bottom: 20px;
  left: 10px;
  opacity: 0;
  z-index: 2;
}

/* --- CAPAS Y POSICIONAMIENTOS DE LOS NUEVOS ELEMENTOS --- */
.confeti-decorativo {
  position: absolute;
  top: 10px;
  width: 450px;
  height: auto;
  opacity: 0;
  z-index: 0;
  pointer-events: none;
}

.confeti-decorativo.c1 {
  left: -10px;
  top:50px;
}

.confeti-decorativo.c2 {
  right: -10px;
  transform: scaleX(-1); /* Espejo para rellenar simétricamente */
}

.lazo-decorativo {
  position: absolute;
  bottom: 20px;
  right: -6px;
      transform: rotate(595deg);

  width: 190px;
  height: auto;
  opacity: 0;
  z-index: -1;
}

.bola-disco-chica {
  position: absolute;
  top: 390px !important;
  left: 15%;
  width: 0px;
  height: auto;
  opacity: 0;
  z-index: 2;
}

.bola-png-decorativa {
  position: absolute;
  bottom: 20px;
  right: 8%;
  width: 210px;
  height: auto;
  opacity: 0;
  z-index: 0;
}

/* =========================
   RASGADOS
========================= */
.rasgado{
  position:absolute;
  left:0;
  width:100%;
  height:50px;
  background:#000000;
  z-index:3;
  margin-top:-40px;
  pointer-events:none;
}

.rasgado-superior{
  top:-40px;
    background:#000000 !important;

  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior{
  bottom:0;    background:#ffffff !important;

  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

.estrella-individual {
  position: absolute;
  top: 720px;
  left: 10%;
  width: 75px;
  height: auto;
  opacity: 0;
  z-index: 3;
}
</style>